export default class FiltroProdutoEstoque {
    constructor () {
        this.UnidadeId= undefined;
        this.RepresentanteId= undefined;
        this.FilialId = undefined;
        this.ClienteId= undefined;
        this.CodigoProduto = undefined;
        this.NomeProduto = undefined;
        this.DescricaoProduto = undefined;
        this.DiasEstoqueMin = undefined; 
        this.DiasEstoqueMax = undefined;
        this.TipoProdutoEstoque = undefined;
        this.Status = undefined;
        this.SegmentoProdutoEstoque = undefined;
        this.ConsultarDadosClienteAgrupador = undefined;
    }
}